export default __webpack_public_path__ + "static/media/exam-orange.36d94684.png";